import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import Button from '../../../components/button';

export default @injectIntl
class NotificationsModal extends React.PureComponent {

  static propTypes = {
    message: PropTypes.node.isRequired,
    confirm: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func,
  };

  componentDidMount() {
  }

  handleClick = () => {
    this.props.onClose();
    this.props.onConfirm();
  }

  setRef = (c) => {
    this.button = c;
  }

  render () {
    const { message, confirm } = this.props;

    return (
      <div className='modal-root__modal confirmation-modal'>
        <div className='confirmation-modal__container'>
          {message}
        </div>

        <div className='confirmation-modal__action-bar'>
          <Button text={confirm} onClick={this.handleClick} ref={this.setRef} className='m-auto' />
        </div>
      </div>
    );
  }

}
